/**
 * @generated SignedSource<<f4ae0447657f63077f0311ec94c18b5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusSubjectNewInput = {
  detailItemId?: string | null;
  nodeId: string;
  scale?: number | null;
  transformX?: number | null;
  transformY?: number | null;
};
export type useOnStorecastLeaveScreenMutation$variables = {
  storecastId: string;
  subject?: StorecastFocusSubjectNewInput | null;
};
export type useOnStorecastLeaveScreenMutation$data = {
  readonly dashboard: {
    readonly setNewFocus: {
      readonly subject: {
        readonly detailItemId: string | null;
        readonly nodeId: string;
      };
    } | null;
    readonly setTemporaryScreenId: {
      readonly id: string;
      readonly screens: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly temporaryScreen: {
        readonly id: string;
      } | null;
    };
  };
};
export type useOnStorecastLeaveScreenMutation = {
  response: useOnStorecastLeaveScreenMutation$data;
  variables: useOnStorecastLeaveScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subject"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "subject",
            "variableName": "subject"
          }
        ],
        "concreteType": "StorecastNewFocus",
        "kind": "LinkedField",
        "name": "setNewFocus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastNewFocusSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detailItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "setTemporaryScreenId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screens",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "temporaryScreen",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOnStorecastLeaveScreenMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnStorecastLeaveScreenMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "c4a383f7f6e6fdcc3479bf2f9fbcac6d",
    "id": null,
    "metadata": {},
    "name": "useOnStorecastLeaveScreenMutation",
    "operationKind": "mutation",
    "text": "mutation useOnStorecastLeaveScreenMutation(\n  $storecastId: ID!\n  $subject: StorecastFocusSubjectNewInput\n) {\n  dashboard(dashboardId: $storecastId) {\n    setNewFocus(subject: $subject) {\n      subject {\n        nodeId\n        detailItemId\n      }\n    }\n    setTemporaryScreenId {\n      id\n      screens {\n        id\n      }\n      temporaryScreen {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55c1850030d3d9df0d30ea2690e6e30e";

export default node;
